import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TaskComponent } from '../task';
import * as _ from "lodash";
import { Howl } from 'howler';


export declare type SingleaudioImageData = {
  type?: string;
  question: string;
  audio: string | Howl;
  options: SingleaudioImageOption[];
};

export interface SingleaudioImageOption {
  image: string;
  correct: boolean;
}

@Component({
  selector: 'app-singleaudioimage',
  templateUrl: './singleaudioimage.component.html',
  styleUrls: ['./singleaudioimage.component.css']
})
export class SingleAudioImageComponent implements TaskComponent, OnInit {

  @Input() data: SingleaudioImageData;
  @Output() taskSubmitted: EventEmitter<boolean> = new EventEmitter();
  public answer: boolean[];
  public isCorrect: boolean[];
  public isAnswered: boolean = false;
  
  constructor() { 

  }

  ngOnInit() {
    if(!this.answer) {
      this.answer = new Array(this.data.options.length).fill(false);
    }
    this.data.audio = new Howl({
      src: [ this.data.audio ]
    });
  }

  submit(i) {
    this.answer[i] = true;
    this.isCorrect = [];
    for(let answerIndex in this.answer) {
      this.isCorrect.push(this.answer[answerIndex] == this.data.options[answerIndex].correct);
    }
    this.taskSubmitted.emit(_.every(this.isCorrect));
    this.isAnswered = true;
  }


}
